import { createContext, useContext } from 'react'
import type { IconComponent } from './components/primitives'

/** The navigation entry being rendered — lets every PageHeader show its page icon automatically. */
export const ActivePageContext = createContext<{ icon?: IconComponent; sectionIcon?: IconComponent } | null>(null)
export const useActivePage = () => useContext(ActivePageContext)
